import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import { useSignIn } from 'react-auth-kit';
import { useIsAuthenticated } from 'react-auth-kit';
import { Box, Typography, Button, TextField, Grid, createTheme, ThemeProvider } from '@mui/material';
import { styled } from '@mui/system';
import Navbarconnexion from '../components/Navbarconnexion';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    border: 'none',
    transition: 'border 0.1s',
    '&:hover': {
      backgroundColor: '#D9D9D9',
    },
    '&.Mui-focused': {
      backgroundColor: '#D9D9D9',
      border: '3px solid black',
    },
    '& input': {
      fontWeight: 'bold', // Make text inside TextField bold
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

function Login() {
  const navigate = useNavigate();
  const signIn = useSignIn();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/');
    }
  }, [isAuthenticated]);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('error');
  const [errMsg, setErrMsg] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleClick = () => {
    setOpen(true);
  };

  const handleForgotPassword = () => {
    const email = 'rocs@cs-sports.fr';
    window.location.href = `mailto:${email}?subject=Password%20Reset&body=Bonjour,%20j'ai%20oublié%20mon%20mot%20de%20passe.%20Pouvez-vous%20m'aider%20à%20le%20réinitialiser%3F`;
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const onSubmit = async (event) => {
    try {
      event.preventDefault();

      await axios.post('/login', {
        email: email,
        password: password,
      }, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content, Accept, Content-Type, Authorization',
        },
      }).then(res => {
        if (res.status === 200) {
          signIn({
            token: res.data.token,
            expiresIn: 60,
            tokenType: 'Bearer',
            authState: { email: email, role: res.data.role, id: res.data.id },
          });
          navigate('/');
        }
      }).catch(error => {
        if (error.response.status === 404) {
          setErrMsg('Utilisateur non trouvé');
          setOpen(true);
        }
        if (error.response.status === 401) {
          setErrMsg('Mauvais mot de passe');
          setOpen(true);
        }
      });
    } catch (err) {
      // Handle error
    }
  };

  return (
    <Box>
      <Navbarconnexion />  
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'rgba(58, 29, 29, 0.1)',
        backgroundImage: `
          repeating-linear-gradient(to right,
            rgba(0, 0, 0, 0) 0%, 
            rgba(0, 0, 0, 0) calc(50% - 1px), 
            #FFFFFF calc(50% - 1px), #FFFFFF calc(50% + 1px),
            rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
          )
        `,
        backgroundSize: 'calc(100% / 5) 100%',
      }}>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
            {errMsg}
          </Alert>
        </Snackbar>
        
        <Box sx={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:{lg:'70%', xs:'90%'}, p:2}}>
          <form onSubmit={onSubmit}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
              <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center',fontSize:{xs:'2rem',md:'3rem'},marginTop:{xs:'5rem'},marginBottom:{xs:'2rem'} }}>CONNEXION</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>ADRESSE EMAIL</Typography>
                  <CustomTextField
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>MOT DE PASSE</Typography>
                  <CustomTextField
                    fullWidth
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    sx={{
                      backgroundColor: '#96013C',
                      color: 'white',
                      padding: '10px 25px',
                      borderRadius: '20px',
                      fontWeight: 'bold',
                      marginTop:'1rem',
                      '&:hover': {
                        backgroundColor: '#96013C',
                      },
                    }}
                    type="submit"
                  >
                    SE CONNECTER
                  </Button>
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Box sx={{ display:'flex', flexDirection:'row', alignItems:'center', marginTop:'2rem' }}>
                    <Button onClick={handleForgotPassword} sx={{ color:'black', fontWeight:'bold', '&:hover': { backgroundColor: 'transparent' } }}>
                      Mot de passe oublié
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
